import { Flex } from "rebass/styled-components";
import ContentLoader from "react-content-loader";

const Placeholder = () => {
  const isMobile = false;

  if (isMobile) {
    return (
      <ContentLoader
        height={"100vh"}
        style={{ width: "100%", padding: "0 16px" }}
        speed={2}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        animate={false}
      >
        {/* Title */}
        <rect x="0" y="16" width="100%" height="30" />
        <rect x="0" y="60" width="70%" height="30" />
        {/* Avatar */}
        <circle cx="80" cy="160" r="40" />
        {/* Name and location */}
        <rect x="160" y="120" width="60" height="14" />
        <rect x="160" y="140" width="80" height="14" />
        <rect x="160" y="160" width="120" height="14" />
        <rect x="160" y="180" width="120" height="14" />
        {/* Tabs */}
        <rect x="16" y="260" width="80" height="14" />
        <rect x="120" y="260" width="100" height="14" />
        {/* Gallery */}
        <rect x="0" y="300" width="100%" height="375" />
      </ContentLoader>
    );
  } else {
    return (
      <Flex py={2} variant="layout.sitterProfile">
        <ContentLoader
          height={"100vh"}
          style={{ width: "100%" }}
          speed={2}
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
          animate={false}
        >
          {/* Avatar */}
          <circle cx="100" cy="90" r="76" />
          {/* Title */}
          <rect x="220" y="20" width="70%" height="30" />
          {/* Name and location */}
          <rect x="220" y="60" width="70" height="14" />
          <rect x="220" y="90" width="100" height="14" />
          <rect x="220" rx={8} ry={8} y="120" width="120" height="14" />
          <rect x="220" rx={8} ry={8} y="150" width="100" height="14" />
          {/* Tabs */}
          <rect x="0" y="240" width="80" height="14" />
          <rect x="100" y="240" width="120" height="14" />
          <rect x="240" y="240" width="100" height="14" />
          <rect x="360" y="240" width="100" height="14" />
          <rect x="480" y="240" width="100" height="14" />
          {/* Gallery */}
          <rect x="0" y="300" width="66%" height="191" />
          <rect x="70%" rx={8} ry={8} y="300" width="30%" height="120" />
          {/* Description */}
          <rect x="0" y="520" width="40%" height="14" />
          <rect x="0" y="550" width="30%" height="14" />
          <rect x="0" y="580" width="20%" height="14" />
        </ContentLoader>
      </Flex>
    );
  }
};

export default Placeholder;
